import type { MessageLink } from '@/model/message-link.ts'
import { endpoints } from '@/api/endpoints.ts'
import { axiosAPI } from '@/api/repository/repository.ts'

class MessageRepository {
  async getMessageAudioLink (messageId: string): Promise<MessageLink> {
    const response = await axiosAPI.get(`${endpoints.message}/${messageId}/link`)
    return response.data
  }
}

export const messageRepository = new MessageRepository()
